import React, {FC} from 'react';

import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {CellsEmptyMessage} from './cellsEmptyMessage';

/*
 * Props.
 */

interface CellsEmptyContainerProps {
  cellsContext: CellsContext;
  isOffline: boolean;
}

/*
 * Component.
 */

/**
 * Rendered when the only item selected in P2 is hidden, in which case P2 is empty but P3 isn't.
 *
 * When both P2 and P3 are empty, `EmptyInboxesContainer` is rendered across P2 and P3 instead.
 */
export const CellsEmptyContainer: FC<CellsEmptyContainerProps> = (props) => (
  <CellsEmptyMessage cellsContext={props.cellsContext} isOffline={props.isOffline} />
);
